var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { QueryGroupMemberInFolderApi } from '../../apis/query-group-member-in-folder-api';
import { TransformCollaborator } from '../../utils/transform-collaborator.interface';
let QueryGroupMemberInFolderRepositoryImpl = class QueryGroupMemberInFolderRepositoryImpl {
    constructor(_queryGroupMemberInFolderApi, _transformCollaborator) {
        this._queryGroupMemberInFolderApi = _queryGroupMemberInFolderApi;
        this._transformCollaborator = _transformCollaborator;
    }
    async queryGroupMemberInFolder(groupId, shareTypeAndId, pager) {
        const request = {
            groupId,
            share_type: shareTypeAndId.shareType,
            share_id: shareTypeAndId.shareId,
            page: pager.page,
            limit: pager.limit,
        };
        const response = await this._queryGroupMemberInFolderApi.queryGroupMemberInFolder(request);
        const records = this._transformResponseToCollaboratorRole(response);
        return {
            records,
            hasNext: response.has_next,
        };
    }
    _transformResponseToCollaboratorRole(response) {
        return response.records.map(collaborator => {
            return this._transformCollaborator.transform(collaborator);
        });
    }
};
QueryGroupMemberInFolderRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(QueryGroupMemberInFolderApi)),
    __param(1, inject(TransformCollaborator)),
    __metadata("design:paramtypes", [typeof (_a = typeof QueryGroupMemberInFolderApi !== "undefined" && QueryGroupMemberInFolderApi) === "function" ? _a : Object, typeof (_b = typeof TransformCollaborator !== "undefined" && TransformCollaborator) === "function" ? _b : Object])
], QueryGroupMemberInFolderRepositoryImpl);
export { QueryGroupMemberInFolderRepositoryImpl };
